import { IS_DEV } from '../../../shared/constants';
import { apiClient } from '../../../shared/lib/apiClient';
import { SERVICE_API, SERVICE_DEV_API } from '../service.constants';
import { ReceiptData } from '../service.types';

export const getFile = async (vmId: number): Promise<void> => {
    const url = IS_DEV
        ? SERVICE_DEV_API.GET_FILE
        : `${SERVICE_API.GET_FILE}?k=${vmId}`;

    await apiClient.post(url);
};

export const getFiscData = async (vmId: number): Promise<ReceiptData> => {
    const url = IS_DEV
        ? SERVICE_DEV_API.GET_FISC_DATA
        : `${SERVICE_API.GET_FISC_DATA}?k=${vmId}`;

    const { data } = await apiClient.post<ReceiptData>(url);
    return data;
};

export const getCheck = async (fiscalId: string): Promise<Blob> => {
    const { data } = await apiClient.get(
        `${SERVICE_API.GET_CHECK}?k=${fiscalId}`,
        { responseType: 'arraybuffer' },
    );
    return new Blob([data], { type: 'application/pdf' });
};
